import { TableColumn } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { deviceTypeTableIcon } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { CommDeviceIdColumnComponent } from 'src/app/pages/equipment/devices/components/column/comm-device-id-column.component';
import { SerialNumberColumnComponent } from 'src/app/pages/equipment/devices/components/column/serial-number-column.component';
import { CommandStatusColumnComponent } from '../components/command-status-column.component';
import { RequestProcessingActionsColumnCancelComponent } from '../components/request-processing-actions-column-cancel/request-processing-actions-column-cancel.component';
import { RequestProcessingActionsColumnRetryComponent } from '../components/request-processing-actions-column-retry/request-processing-actions-column-retry.component';

const createBaseColumns = (): TableColumn[] => [
  {
    field: 'commDeviceId',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.COMM_DEVICE_ID,
    width: 200,
    sticky: true,
    sortable: true,
    cmp: CommDeviceIdColumnComponent
  },
  {
    field: 'serialNumber',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.SERIAL_NUMBER,
    width: 200,
    sticky: true,
    sortable: true,
    cmp: SerialNumberColumnComponent
  },
  {
    field: 'deviceType',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.DEVICE_TYPE,
    width: 130,
    sticky: true,
    sortable: true,
    icon: deviceTypeTableIcon
  },
  {
    field: 'command',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.COMMAND,
    width: 220,
    sortable: true
  },
  {
    field: 'commandStatus',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.COMMAND_STATUS,
    width: 180,
    sortable: true,
    cmp: CommandStatusColumnComponent
  },
  {
    field: 'scheduledDateTime',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.SCHEDULED_DATE_TIME,
    width: 220,
    sortable: true
  },
  {
    field: 'startDateTime',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.START_DATE_TIME,
    width: 220,
    sortable: true
  },
  {
    field: 'completedDateTime',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.COMPLETED_DATE_TIME,
    width: 240,
    sortable: true
  },
  {
    field: 'actionName',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.COMMAND_GROUP_NAME,
    width: 200,
    sortable: true
  },
  {
    field: 'imageName',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.IMAGE_NAME,
    width: 200,
    sortable: true
  },
  {
    field: 'user',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.USER,
    width: 180,
    sortable: true
  }
];

const createCancelButtonColumn = (): TableColumn[] => [
  {
    field: 'cancelScheduled',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.CANCEL_SCHEDULED,
    width: 150,
    sortable: false,
    cmp: RequestProcessingActionsColumnCancelComponent
  }
];

const createRetryButtonColumn = (): TableColumn[] => [
  {
    field: 'retryScheduled',
    title: TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.VIEW_TABLE.RETRY_FAILED,
    width: 120,
    sortable: false,
    cmp: RequestProcessingActionsColumnRetryComponent
  }
];

export const createRequestProcessingColumns = (opts: {
  hasCancelPermission: boolean;
  hasRetryPermission: boolean;
}): TableColumn[] => [
  ...createBaseColumns(),
  ...(opts.hasCancelPermission ? createCancelButtonColumn() : []),
  ...(opts.hasRetryPermission ? createRetryButtonColumn() : [])
];
